import { useQuery } from 'react-query'
import axios from '../../utils/http/axios-disputer'

const getSelectOptions = async () => axios.get('/api/alerts/get_select_options')

const useSelectOptions = () => {
  return useQuery('alertSearchOptions', getSelectOptions, {
    staleTime: Infinity
  })
}

export default useSelectOptions
